export const sentryEventId = eventId => ({
  type: 'SENTRY_EVENT_ID',
  eventId,
});
